// account
export const SET_ACCOUNT = 'setAccount';
export const SET_SESSION_TOKEN = 'setToken';

// users
export const SET_USER = 'setUser';
export const SET_USERS = 'setUsers';

// organization
export const SET_ORGANIZATION = 'setOrganization';
export const SET_ORGANIZATIONS = 'setOrganizations';

// donation
export const SET_DONATION = 'setDonation';
export const SET_DONATIONS = 'setDonations';

// announcement
export const SET_ANNOUNCEMENT = 'setAnnouncement';
export const SET_ANNOUNCEMENTS = 'setAnnouncements';

// folder
export const SET_FOLDER = 'setFolder';
export const SET_FOLDERS = 'setFolders';

// template
export const SET_TEMPLATE = 'setTemplate';
export const SET_TEMPLATES = 'setTemplates';
export const SET_EVENT_TEMPLATE = 'setEventTemplate';
export const SET_EVENT_TEMPLATES = 'setEventTemplates';

// screen
export const SET_SCREEN = 'setScreen';
export const SET_SCREENS = 'setScreens';

// yurtzeiten
export const SET_YURTZEITEN = 'setYurtzeiten';
export const SET_YURTZEITENS = 'setYurtzeitens';

// yurtzeiten_template
export const SET_YURTZEITEN_TEMPLATE = 'setYurtzeitenTemplate';
export const SET_YURTZEITEN_TEMPLATES = 'setYurtzeitenTemplates';

// yurtzeiten_email_template
export const SET_YURTZEITEN_EMAIL_TEMPLATE = 'setYurtzeitenEmailTemplate';
export const SET_YURTZEITEN_EMAIL_TEMPLATES = 'setYurtzeitenEmailTemplates';

// recentPhoto
export const SET_RECENT_PHOTO = 'setRecentPhoto';
export const SET_RECENT_PHOTOS = 'setRecentPhotos';

// event
export const SET_EVENT = 'setEvent';
export const SET_EVENTS = 'setEvents';
export const SET_UPCOMING_EVENTS = 'setUpcomingEvents';

// weeklyEvent
export const SET_WEEKLY_EVENT = 'setWeeklyEvent';
export const SET_WEEKLY_EVENTS = 'setWeeklyEvents';

// weeklySchedule_N
export const SET_WEEKLY_SCHEDULES_N = 'setWeeklySchedules_N';
export const SET_WEEKLY_SCHEDULE_N = 'setWeeklySchedule_N';
export const SET_WEEKLY_SCHEDULE_N_RECORD = 'setWeeklyScheduleRecord_N';

// photoUnderline
export const SET_PHOTO_UNDERLINE = 'setPhotoUnderline';
export const SET_PHOTO_UNDERLINES = 'setPhotoUnderlines';

// minyanim
export const SET_MINYANIM = 'setMinyanim';
export const SET_MINYANIMS = 'setMinyanims';

// minyanim_type
export const SET_MINYANIM_TYPE = 'setMinyanimType';
export const SET_MINYANIM_TYPES = 'setMinyanimTypes';

// zmanim
export const SET_ZMANIM = 'setZmanim';
export const SET_ZMANIMS = 'setZmanims';

// ticket
export const SET_TICKET = 'setTicket';
export const SET_TICKETS = 'setTickets';
export const SET_TICKET_UNREAD = 'setTicketUnread';
export const SET_TICKET_IN_LIST = 'setTicketInList';

// ticket_comment
export const SET_TICKET_COMMENT = 'setTicketComment';
export const SET_TICKET_COMMENTS = 'setTicketComments';
export const SET_TICKET_IN_THREAD = 'setTicketInThread';

// date_time_banner
export const SET_DATE_TIME_BANNER = 'setDateTimeBanner';
export const SET_DATE_TIME_BANNERS = 'setDateTimeBanners';

// stats
export const SET_DASHBOARD_STATS = 'setDashboardStats';

// sidenav
export const SET_SIDENAV = 'setSidenav';

// router_loader
export const SET_ROUTER_LOADER = 'setRouterLoader';

// error
export const SET_ERRORMSG = 'setErrorMsg';

// zmanim_N
export const SET_ZMANIM_N = 'setZmanim_N';
export const SET_ZMANIMS_N = 'setZmanims_N';

// screen_artboard
export const SET_SCREEN_ARTBOARD = 'setScreenArtboard';
export const SET_SCREEN_ARTBOARDS = 'setScreenArtboards';
export const SET_SCREEN_ARTBOARD_CONTENT = 'setScreenArtboardContent';

// yurtzeiten_N
export const SET_YURTZEITEN_N = 'setYurtzeiten_N';
export const SET_YURTZEITENS_N = 'setYurtzeitens_N';
export const SET_YURTZEITEN_N_STATS = 'setYurtzeitenStats_N';
export const SET_YURTZEITEN_DESIGN_N = 'setYurtzeitenDesign_N';

// zmanim display override N
export const SET_ZMANIM_DISPLAY_OVERRIDE_N = 'setZmanimDisplayOverride_N';
export const SET_ZMANIM_DISPLAY_OVERRIDES_N = 'setZmanimDisplayOverrides_N';

// room
export const SET_ROOM = 'setRoom';
export const SET_ROOMS = 'setRooms';

// minyan_roll_N
export const SET_MINYAN_ROLL_N = 'setMinyanRoll_N';
export const SET_MINYAN_ROLLS_N = 'setMinyanRolls_N';

// minyan_N
export const SET_MINYAN_N = 'setMinyan_N';
export const SET_MINYANS_N = 'setMinyans_N';

// custom_font
export const SET_CUSTOM_FONT = 'setCustomFont';
export const SET_CUSTOM_FONTS = 'setCustomFonts';
